import React from "react"

export default ({ name, label: _label } = {}) => ({
  name,
  type: "boolean",
  component: ({ name: _name, value: _value, onChange: _onChange }) => {
    return <div>Toggle</div>
  }
})
